export enum ButtonTypes {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  WITH_INPUT = "with_input",
  PRIMARY_WITH_ARROW = "primary_with_arrow",
}
